import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { DIVIDER_TYPE } from "../defaults";
import { withSafariSvgCaretFixer } from "./withSafariSvgCaretFixer";
const lineProps = (width, lineDistance = 1) => ({
  x2: width,
  y1: lineDistance,
  y2: lineDistance
});
const getLines = (type, width, multilineDistance = 7) => {
  const linePropsArr = [lineProps(width)];
  if (type === DIVIDER_TYPE.LINE_DOUBLE) {
    linePropsArr.push(lineProps(width, multilineDistance));
  }
  return linePropsArr;
};
const DividerLine = ({
  type,
  size,
  alignment,
  width,
  multilineDistance,
  styles,
  className,
  fillParent,
  isMobile
}) => {
  const linesPropsArr = getLines(type, width, multilineDistance);
  const lineClassName = classNames(
    styles.divider,
    styles[`divider--${type}`],
    styles[`divider--${size}${isMobile ? "--mobile" : ""}`],
    styles[`divider--${alignment}`],
    fillParent ? styles["divider--fill-parent"] : "",
    className
  );
  return withSafariSvgCaretFixer(
    /* @__PURE__ */ React.createElement("svg", { className: lineClassName }, linesPropsArr.map((lineProp, i) => /* @__PURE__ */ React.createElement("line", { key: i, ...lineProp })))
  );
};
DividerLine.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  alignment: PropTypes.string,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  multilineDistance: PropTypes.number,
  fillParent: PropTypes.bool,
  isMobile: PropTypes.bool
};
var divider_line_default = DividerLine;
export {
  divider_line_default as default
};
//# sourceMappingURL=divider-line.js.map
